/*
 * @Author: Yumeng Xue
 * @Date: 2024-12-01 01:02:19
 * @LastEditTime: 2024-12-02 01:25:41
 * @LastEditors: Yumeng Xue
 * @Description: 
 * @FilePath: /line-similarity/src/index.tsx
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { roaringLibraryInitialize } from "roaring-wasm";

await roaringLibraryInitialize();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
